'use client'

import Cookies from 'js-cookie'
import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { Toaster } from 'react-hot-toast'

import { SignInPopupWrapper } from '@/modules/auth'
import { appSelectors, useAppStore } from '@/store'
import '@/store/app.subscription'
import { Message } from '@/components/ui'
import { When } from 'react-if'
import { PieChartIcon } from '@radix-ui/react-icons'
import { Config } from '@/config'
import { CookieConsent } from '@/modules/cookie-consent'

export const ClientWrapper: React.FC<
  PropsWithChildren & { locale?: string }
> = ({ locale = Config.FALLBACK_LANG }) => {
  const loading = useAppStore(appSelectors.loading)
  const { user } = useAppStore(appSelectors.auth)
  const { fetchUser } = useAppStore(appSelectors.asyncActions)
  const { setLocale } = useAppStore(appSelectors.actions)
  const token = Cookies.get('access_token')
  const [initialized, setInitialized] = useState<boolean>(false)

  const initializeUser = useCallback(async () => {
    await fetchUser()
    setInitialized(true)
  }, [fetchUser])

  useEffect(() => {
    if (!user && token) {
      initializeUser()
    } else {
      setInitialized(true)
    }

    return () => {
      setInitialized(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user])

  useEffect(() => {
    setLocale(locale)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale])

  if (!initialized) {
    return <></>
  }

  return (
    <>
      <Message isInline />
      <Toaster position="top-center" />
      <div className="text-center">{loading && <></>}</div>
      <SignInPopupWrapper />
      <CookieConsent />
      <When condition={loading}>
        <div className="fixed z-[9999] w-full h-full bg-primary/80 flex flex-col justify-center items-center">
          <PieChartIcon className="animate-spin text-white/30 w-20 h-20" />
        </div>
      </When>
    </>
  )
}
